import { render, staticRenderFns } from "./HistoryBaby.vue?vue&type=template&id=6fbeffc6&scoped=true"
import script from "./HistoryBaby.vue?vue&type=script&lang=js"
export * from "./HistoryBaby.vue?vue&type=script&lang=js"
import style0 from "./HistoryBaby.vue?vue&type=style&index=0&id=6fbeffc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbeffc6",
  null
  
)

export default component.exports